<template>
  <div id="app">
    <CardRecycling />
  </div>
</template>

<script>
import CardRecycling from './components/CardRecycling.vue'

export default {
  name: 'App',
  components: {
    CardRecycling
  },
  mounted() {
     console.error = function() {};
    console.log = function() {};
    
  },
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  width: 100%;
  min-height: 100vh;
}
</style>
